<template>
    <div class="w-full h-full px-2 md:px-4 lg:px-8 py-8">
        <div class="w-full flex mb-4 justify-between">
            <p class="dark:text-gray-200 text-gray-700 text-2xl tracking-widest uppercase">Lista de produtos</p>
        </div>
        <div class="w-full flex mb-1 justify-between gap-x-4">
            <span class="text-gray-200 text-3xl uppercase w-1/4"> </span>
            <div class="flex-1 px-5 flex flex-row items-center gap-x-2" >
                <p class="uppercase text-gray-500 dark:text-gray-300 text-xs">Pesquisar produto: </p>
                <input :disabled="modelo === ''" v-model="searchComplemento" class="bg-transparent text-gray-500 border-b border-gray-500 dark:border-indigo-200 transition-all duration-300 focus:border-indigo-500 disabled:opacity-50"/>
            </div>
        </div>
        <div class="flex flex-row gap-x-4 w-full">
            <div class="pt-2 w-1/4 flex-none h-40 sticky rounded-lg">
                <div class="w-4/5 m-auto py-4 flex flex-col gap-y-4">
                    <p class="text-2xl dark:text-gray-300 text-gray-700">Filtros</p>
                    <span class="w-full md:flex-1">
                        <Autocomplete :validation="v$.seg" v-model="segmento" label="Segmento" placeholder="Selecionar complemento" :list="segmentos" desc="descricao" @filter="filterMarcas()"/>
                    </span>
                    <span class="w-full md:flex-1">
                        <Autocomplete v-model="marca" label="Marca" placeholder="Selecionar marca" :list="marcas" desc="marca" @filter="filterModelos()"/>
                    </span>
                    <span class="w-full md:flex-1">
                        <Autocomplete v-model="modelo" label="Modelo" placeholder="Selecionar modelo" :list="modelos" desc="descricao" @filter="filterComplementos()"/>
                    </span>
                </div>
            </div>
            <div id="lojas-section" class="w-3/4 flex-none flex flex-col flex-wrap gap-y-4 mt-2">
                <div v-if="!segmento || !marca || !modelo" class="dark:text-gray-400 text-gray-500 dark:bg-gray-800 bg-gray-200 w-full h-auto rounded-lg flex flex-col items-center justify-center py-5 px-5">
                    <span class="text-5xl material-icons-outlined">
                        filter_alt
                    </span>
                    <p class="text-lg">Selecione filtros para iniciar a pesquisa   </p>
                </div>
                <div v-else-if="false" class="dark:text-gray-400 text-gray-500 dark:bg-gray-800 bg-gray-200 w-full h-24 rounded-lg flex flex-col items-center justify-center py-2 px-5">
                    <p class="text-lg">Nenhum resultado encontrado para essa pesquisa</p>
                </div>
                <span v-else v-for="c, i in filteredListComplementos" :key="i" class="w-full">
                    <div class="dark:bg-gray-800 bg-gray-100 border border-gray-200 dark:border-gray-700 h-24 rounded-lg shadow-lg flex items-center px-4 gap-x-4">
                        <span class="material-icons-outlined text-6xl text-gray-700 select-none">
                            add_photo_alternate
                        </span>
                        <span>
                            <p class="text-sm text-indigo-500">#{{c.id}}</p>
                            <p class="text-gray-700 dark:text-indigo-200 text-xl">{{c.descricao}}</p>
                        </span>

                    </div>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import Input from '@/components/Design/Input'
import Autocomplete from '@/components/Design/Autocomplete'
import Select from '@/components/Design/Select'
import { GET_SEGMENTOS, GET_MODELOS_BY_MARCA, GET_MARCAS_BY_SEGMENTO, GET_COMPLEMENTOS_BY_MODELO } from '../../mixins/api.js'
import {computed, onMounted, ref} from 'vue'
import useVuelidate from '@vuelidate/core'
import { findId } from '../../mixins/findData.js'
export default {
    name: 'ListaProdutos',
    components: {
        Input,
        Select,
        Autocomplete
    },
    setup() {
        const segmentos = ref([])
        const segmento = ref('')
        const marcas = ref([])
        const marca = ref('')
        const modelos = ref([])
        const modelo = ref('')
        const complementos = ref('')
        const complemento = ref('')
        const searchComplemento = ref('')

        const filterMarcas = (async () => {
            if(segmento.value === '') {
                marca.value =
                modelo.value = ''
                complemento.value = ''
                
            } else {
                const id = findId(segmentos.value, segmento.value, 'descricao')
                await GET_MARCAS_BY_SEGMENTO(id).then(r => {
                    marcas.value = r.data
                })
            }
        })

        const filterModelos = (async () => {
            if(marca.value === '') {
                modelo.value = ''
                complemento.value = ''
            }else {
                const id = findId(marcas.value, marca.value, 'marca')
                await GET_MODELOS_BY_MARCA(id).then(r => {
                    modelos.value = r.data
                    
                })
            }
        })

        const filterComplementos = (async () => {
            if(modelo.value === '') {
                complemento.value = ''
            }else {
                const id = findId(modelos.value, modelo.value, 'descricao')
                await GET_COMPLEMENTOS_BY_MODELO(id).then(r => {
                    complementos.value = r.data
                    
                })
            }

        })

        const filteredListComplementos = computed(() => {
            if(complementos.value.length == 0)
                return complementos.value
            return complementos.value.filter(x => x.descricao.toLowerCase().includes(searchComplemento.value.toLowerCase()))
        })

        const getLists = (async() => {
            await GET_SEGMENTOS().then(r => {
                segmentos.value = r.data
            })
            filterModelos()
        })


        onMounted(async () => {
            await getLists()
        })

        const rules = computed(() => {
            return {
                segmento: 
                    {uincludes: (value) => segmentos.value.map(a => a.descricao).includes(value.value)}
                
            }
        })
        const v$ = useVuelidate(rules, { segmento })

        return {
            segmentos,
            segmento,
            marcas,
            marca,
            modelos,
            modelo,
            complemento,
            complementos,
            searchComplemento,
            filteredListComplementos,
            v$,
            filterMarcas,
            filterModelos,
            filterComplementos,

        }
    }
}
</script>
<style>
</style>